import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { URL } from '../../util/ambienteActions';
import { ATIVAR_ITINERARIO, INATIVAR_ITINERARIO } from '../types';

export function ativarItinerario(codigoEmpresa, codigoItinerario) {
    const url = `${URL}/itinerario/${codigoEmpresa}/ativar/${codigoItinerario}`;
        
    return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
        type: ATIVAR_ITINERARIO,
        payload: response
        })
    );
}

export function inativarItinerario(codigoEmpresa, codigoItinerario) {
    const url = `${URL}/itinerario/${codigoEmpresa}/inativar/${codigoItinerario}`;

    return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
        type: INATIVAR_ITINERARIO,
        payload: response
        })
    );
}